export default "/f/static/header_assets/img/s_catalogs.svg";